<template>
  <div class="payment-meters" :class="{'show-in-lines': smallScreen}">
    <span class="meter-item" v-for="m in metersData" :key="m.icon">
      <VcitaMeter
        :single-line="smallScreen"
        :title="m.title"
        :value="m.value"
        :icon="m.icon"/>
    </span>
  </div>
</template>

<script>
import {VcitaMeter} from "@/modules/common/components"
export default {
  name: 'PaymentMeters',
  components: {
    VcitaMeter
  },
  props: {
    meters: {
      type: Object,
      requried: true
    },
    smallScreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    metersData() {
      if (!this.meters) return []
      return [
        {title: this.$t('payment.summary.past_due'), value: this.meters.past_due, icon: 'pending-payments'},
        {title: this.$t('payment.summary.outstanding'), value: this.meters.outstanding, icon: 'expired'},
        {title: this.$t('payment.summary.recieved'), value: this.meters.paid_payments, icon: 'hand-cash'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';
.payment-meters {
  display: flex;
  padding: 10px;

  .meter-item {
    display: flex;
    justify-content: center;
    flex: 33%;

    &:not(:last-child) {
      @include i-border-right(1px solid $grey-color-2);
    }
  }

  &.show-in-lines {
    flex-direction: column;
    padding: 15px 22px;

    .meter-item {
      width: 100%;

      &:not(:last-child) {
        margin: 0 0 15px 0;
        padding: 0 0 15px 0;
        @include i-border-right(none);
        border-bottom: 1px solid $grey-color-2;
      }
    }
  }
}
</style>